<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>개체정보</div>
      <!-- Breadcrumb right aligned-->
      <!-- <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">개체정보</li>
      </ol> -->
    </div>

    <!-- 상세 -->
    <div class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered" style="background-color: #f7f7f7;">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>파일시퀀스</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.fileSeq')}"
                       v-model="data.row.fileSeq" placeholder="fileSeq" v-validate="''" name="fileSeq"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.fileSeq')" class="invalid-feedback">{{
                    errors.first('edit.fileSeq')
                  }}</span>
              </td>
              <th>개체유형</th>
              <td>
                <span>{{getFileTypeName(data.row.fileTypeCd)}}</span>
              </td>
            </tr>
            <tr>
              <th>개체출처</th>
              <td>
                 <span>{{getFileDivName(data.row.fileDivCd)}}</span>
              </td>
              <th>외부개체ID</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.extFileId')}"
                       v-model="data.row.extFileId" v-validate="''" name="extFileId"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.extFileId')" class="invalid-feedback">{{errors.first('edit.extFileId')}}</span>
              </td>
            </tr>
             <tr v-show="!exterUrl && !contentsUrl">
              <th>원본파일명</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.orgFileNm')}"
                       v-model="data.row.orgFileNm" placeholder="orgFileNm" v-validate="''" name="orgFileNm"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.orgFileNm')" class="invalid-feedback">{{errors.first('edit.orgFileNm')}}</span>
              </td>
              <th>파일크기</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.size')}"
                       :value="orgFileSize" placeholder="size" v-validate="''" name="size" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.size')" class="invalid-feedback">{{ errors.first('edit.size') }}</span>
              </td>
            </tr>
            <tr>
              <th>등록자/등록일</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.regId')}"
                       :value="data.row.regId+'('+data.row.regDt+')'" placeholder="regId" v-validate="''" name="regId" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.regId')" class="invalid-feedback">{{ errors.first('edit.regId') }}</span>
              </td>
              <th>수정자/수정일</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.regDt')}"
                       :value="data.row.updId+'('+data.row.updDt+')'" placeholder="regDt" v-validate="''" name="regDt" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.regDt')" class="invalid-feedback">{{ errors.first('edit.regDt') }}</span>
              </td>
            </tr>
          </table>
          <table class="table table-bordered mt-4">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr v-show="!exterUrl && !contentsUrl">
              <th>원본파일</th>
              <td colspan='4'>
                <div class="custom-file">
                  <input type="file" class="display-file" id="fileInfo" @change="insertFileName">
                  <label class="custom-file-label" for="fileInfo">{{fileName}}</label>
                  <!-- <img class="popupImageItem" :src="uploadImageFile"> -->
                  <div class="file-info">
                     <span>원본 경로 : {{data.row.url}}</span>
                     <div class="button-wrap">
                        <b-btn class="btn mr-2" @click="downloadAs(data.row.fileDivCd,data.row.url,data.row.orgFileNm)"><i class="fa fa-download mr-1"></i>다운로드</b-btn>
                     </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-show="!exterUrl && !contentsUrl">
              <th>미리보기파일</th>
              <td colspan='4'>
                <div class="custom-file">
                  <div class="form-check mb-2">
                    <input class="form-check-input" v-model="data.row.contentsViewFileUploadYn" true-value="Y" false-value="N" type="checkbox"/>
                    <label class="form-check-label">VIEW용 PDF 업로드(첨부파일이 PDF로 변환이 불가한 경우)</label>
                  </div>
                  <input type="file" accept=".pdf" :disabled="data.row.contentsViewFileUploadYn == 'N'" class="display-file" id="previewFileInfo" @change="insertPreviewFileName">
                  <label class="custom-file-label" for="previewFileInfo" :style=" {backgroundColor: data.row.contentsViewFileUploadYn == 'N' ? 'lightgray' : '' } ">{{previewFileName}}</label>
                  <div class="file-info">
                     <span>미리보기 경로 : {{data.row.contentsViewFilePath}}</span>
                     <div class="button-wrap">
                        <b-btn class="btn" @click="goViewFileUrl(data.row.contentsViewFilePath)" v-show="!mediaFile"><i class="fa fa-search mr-1"></i>미리보기</b-btn>
                     </div>
                  </div>
                  <div class="file-info" style="color:red;height:20px;margin-top:0;">
                    <span>※미리보기파일을 등록하지 않을 경우 원본파일이 PDF로 자동변환됩니다.</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-show="exterUrl || contentsUrl">
              <th>링크경로</th>
              <td colspan="4">
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.linkUrl')}"
                       v-model="data.row.linkUrl" placeholder="linkUrl" v-validate="''" name="linkUrl"/>
                <b-btn class="btn" @click="openTabPreview(data.row.linkUrl)"><i class="fa fa-search mr-1"></i>링크열기</b-btn>
              </td>
            </tr>
            <tr>
              <th>
                <span>썸네일링크</span>
              </th>
              <td colspan="3">
                  <input type="text" v-model="data.row.thumbnailPath"  :class="{'form-control':true}"
                      name="thumbnailPath" style="width: 100%" placeholder="Url..."/>
              </td>
            </tr>
            <tr>
              <th>노출개체명*</th>
              <td colspan="4">
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.dispFileNm')}"
                       v-model="data.row.dispFileNm" placeholder="dispFileNm" v-validate="''" name="dispFileNm"
                       style="width: 100%"/>
                <span v-show="errors.has('edit.dispFileNm')" class="invalid-feedback">{{
                    errors.first('edit.dispFileNm')
                  }}</span>
              </td>
            </tr>
           <tr>
             <th>노출대상*</th>
              <td colspan="4">
                <b-input-group>
                   <div>
                      <div class="form-check mb-2">
                        <input class="form-check-input" v-model="data.row.teacherUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label">교사사용</label>
                        <input class="form-check-input ml-2" v-model="data.row.tutorUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">강사사용</label>
                        <input class="form-check-input ml-2" v-model="data.row.studentUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">학생사용</label>
                      </div>
                   </div>
                 </b-input-group>
              </td>
           </tr>
           <tr>
              <th>키워드</th>
              <td colspan='3'>
                <Keyword :box="keywords.box" :boxText="keywords.text" :type="'key'" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="keywords.text"/>
              </td>
            </tr>
            <tr>
              <th>태그</th>
              <td colspan='3'>
                <Keyword :box="tags.box" :boxText="tags.text" :type="'tag'" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="tags.text"/>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div v-if="popupType == 'txt'">
      <div div class="content-heading mt-1" >
        <div>매핑정보</div>
      </div>
      <div class="card card-default">
        <div class="card-body">
          <form data-vv-scope="editMpp">
            <table class="table table-bordered">
              <colgroup>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
              </colgroup>
              <tr>
                <th>콘텐츠 용도</th>
                <td>
                  <b-input-group>
                    <div>
                      <!-- <b-form-select v-model="dataMpp.row.purpTypeCd" :options="purpTypeCd">
                      </b-form-select> -->
                      <b-form-select v-model="dataMpp.row.purpTypeCd" :options="exterUrl? purpTypeCd_exterUrl : purpTypeCd" @change="exterUrl_addition1 = dataMpp.row.purpTypeCd == '209007'; exterUrl_addition2 = false; exterUrl_addition3 = false; dataMpp.row.purpTypeCd_sub1 = undefined; dataMpp.row.purpTypeCd_sub2 = undefined; dataMpp.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub1_options = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd && cd.p_code.endsWith(dataMpp.row.purpTypeCd))"></b-form-select>
                      <div v-show="exterUrl && exterUrl_addition1" class="mt-1">
                        <b-form-select v-model="dataMpp.row.purpTypeCd_sub1" :options="purpTypeCd_sub1_options" @change="exterUrl_addition2 = true; exterUrl_addition3 = false; purpTypeCd_sub2 = undefined; dataMpp.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub2_options = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd_sub1 && cd.p_code.endsWith(dataMpp.row.purpTypeCd_sub1))"></b-form-select>
                      </div>
                      <div v-show="exterUrl && exterUrl_addition1 && exterUrl_addition2" class="mt-1">
                        <b-form-select v-model="dataMpp.row.purpTypeCd_sub2" :options="purpTypeCd_sub2_options" @change="exterUrl_addition3 = true; dataMpp.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub3_options = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd_sub2 && cd.p_code.endsWith(dataMpp.row.purpTypeCd_sub2))"></b-form-select>
                      </div>
                      <div v-show="exterUrl && exterUrl_addition1 && exterUrl_addition2 && exterUrl_addition3" class="mt-1">
                        <b-form-select v-model="dataMpp.row.purpTypeCd_sub3" :options="purpTypeCd_sub3_options"></b-form-select>
                      </div>
                    </div>
                  </b-input-group>
                </td>
                <th>유료여부</th>
                <td>
                  <b-input-group>
                    <div>
                      <div class="form-check mb-2">
                        <input class="form-check-input" id='form-check-payYn' v-model="dataMpp.row.payYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label" for='form-check-payYn'>유료</label>
                      </div>
                      <div> ※ 체크하면 유료로 전환됩니다.</div>
                    </div>
                  </b-input-group>
                </td>
              </tr>
              <tr v-if="data.row.fileTypeCd=='211002'">
                <th>동영상 재생구간</th>
                <td>
                  <b-input-group>
                    <span class="mt-1 mr-2">시작</span>
                    <input type="text" v-model="dataMpp.row.playStartTime" 
                      :class="{'form-control':true, 'is-invalid': errors.has('editMpp.playStartTime')}"
                      v-validate="'min_value:0'"  name="playStartTime"
                      :disabled="page.playAll"/>
                    <span class="mt-1 ml-2 mr-2">~ 종료</span>
                    <input type="text" v-model="dataMpp.row.playEndTime" 
                      :class="{'form-control':true, 'is-invalid': errors.has('editMpp.playEndTime')}"
                      v-validate="'min_value:0'"  name="playEndTime"
                      :disabled="page.playAll"/>
                    <input class="mt-2 ml-2" type="checkbox" v-model="page.playAll" id="playAll"
                      @change="playAllChanged()">
                    <label class="mt-1 ml-1" for="playAll">전체구간</label>
                  </b-input-group>
                </td>
                <th colspan="2"><span > ※ 일부구간만 재생 시 설정해주세요.</span></th>
              </tr>
              <tr>
                <th>등록자/등록일</th>
                <td>
                  <input type="text" :class="{'form-control':true}"
                    :value="dataMpp.row.regId+'('+dataMpp.row.regDt+')'" name="regId" style="width: 100%"
                    readonly/>
                </td>
                <th>수정자/수정일</th>
                <td>
                  <input type="text" :class="{'form-control':true}" 
                    :value="dataMpp.row.updId+'('+dataMpp.row.updDt+')'" name="regDt" style="width: 100%"
                    readonly/>
                </td>
              </tr>
            </table>
          </form>
        </div>
        <div class="card-footer">
          <div class="card-tool float-right">
            <b-button @click="close()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
            <b-button @click="removeMpp()" class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">매핑삭제</b-button>
            <b-button @click="saveAll()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2 px-3">저장</b-button>
          </div>
        </div>
     </div>
    </div>
    <div v-else>
      <div div class="content-heading mt-1">
          <div>매핑목록({{dataMppList.row.length}})</div>
      </div>
      <div class="card card-default">
        <div class="card-body">
          <form data-vv-scope="editMppList">
            <table class="table table-striped table-bordered table-hover">
              <colgroup>
                <col width="14%%"/>
                <col width="50%%"/>
                <col width="13%"/>
                <col width="13%"/>
                <col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <td class="text-center">매핑 ID</td>
                  <td class="text-center">매핑위치</td>
                  <td class="text-center">콘텐츠용도</td>
                  <td class="text-center">유료여부</td>
                  <td class="text-center">자세히보기</td>
                </tr>
              </thead>
              <tbody>
                <tr v-show="dataMppList.row.length==0" class="text-center">
                  <td colspan="5">No matching records</td>
                </tr>
                <tr v-for="(item, index) in dataMppList.row" :key="index">
                  <td>{{item.mappingSeq}}</td>
                  <td>{{item.mapLocation}}</td>
                  <td>{{item.purpTypeCd}}</td>
                  <td>{{item.payYn}}</td>
                  <td class="text-center">
                    <div>
                      <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="popupOpen(item,index);"><em class="fa fa-search"></em></b-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
    <div class="footer" v-show="parentType=='file' || _saveType == 'ins'">
      <div class="float-right">
          <b-button @click="insClose()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="updateDelete()" class="btn btn-b btn-info mr-2" variant="info mr-2">삭제</b-button>
          <b-button @click="save()" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
      </div>
    </div>
    <a id="fileDown" style="display:none;"></a> <!-- 다운로드용 가상 a-->   
    <a id="filePreview" style="display:none;" target="_blank" ></a> <!-- 미리보기용 가상 a-->    
    <!-- // 상세 -->
    <b-modal id="fileModal" size="xl" title="교과서정보" v-model="popupTextBookInfo" hide-footer>
      <CsTextBookPageInfo :fileSeq="AddfileSeq" :orgContSeq="AddcontSeq" :mppdata="dataMpp" key="atrbInfo.fileSeq" :parentType="'file'" @modal-state="close"/>
    </b-modal>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsFileList, getCsFileItem, saveCsFile, deleteCsFile, getCsFileListByMomentMapp, saveUpdateCsFile, deleteUpdateCsFile} from "@/api/cs/CsFileApi";
import {getCsFileMappingItem, saveCsFileMapping, deleteCsFileMapping,getCsFileMappingList, getCsFileMappingLocationList} from "@/api/cs/CsFileMappingApi";
import {saveMomentFileMapping, getMomentFileMappingItem, deleteMomentFileMapping} from "@/api/exhibit/moment/MomentMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, purpTypeCd,purpTypeCd_exterUrl,purpTypeCd_exterUrl_sub , getFileTypeName, getFileDivName, fileDivCdMap, aws_cdn_path} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Keyword from "../../components/Common/Keyword";
import Datepicker from 'vuejs-datepicker';
import Axios from 'axios';
import CsTextBookPageInfo from '../cs/CsTextBookPageInfo'

export default {
  components: {SchDateRange, SchText, Pagenation, Datepicker,CsTextBookPageInfo,Keyword},
  props: {
    datainfo: '',
    fileSeq: '',
    contSeq: Number,
    orgContSeq : Number,
    isShow: Boolean,
    parentType : '',
    saveType : '',
    mappingSeq : '',
    atrbInfo:[],
  },
  setup(props, context) {
    const schOptions = [{value: 'disp_file_nm', text: '파일명'}, {value: 'ext_file_id', text: '파일 아이디'},{value: 'org_file_nm', text: '원본파일명'}]
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const _dataObjectMpp = _.cloneDeep(dataObject); // 매핑정보용 객체
    const _dataObjectMppList = _.cloneDeep(dataObject); // 매핑정보용 객체
    const data = reactive(_dataObject) //reactive 반응형 
    const dataMpp = reactive(_dataObjectMpp); 
    const dataMppList = reactive(_dataObjectMppList) //reactive 반응형 
    data.schOptions = schOptions // 검색 type 선택 
    const orgFileSize = ref('');

    const keywords = reactive({
      box : [],
      text : '',
    });
    const tags = reactive({
      box : [],
      text : '',
    });

    const page = reactive({
      playAll:true,
    })

    // const uploadImageFile = ref('');
    const fileName = ref('Choose a file...');
    const filedata = ref('');
    const previewFileName = ref('Choose a file...');
    const previewFileData = ref('');

    const docFile = ref(true); //문서파일
    const mediaFile = ref(false); //멀티미디어
    const exterUrl = ref(false); //외부링크
    const exterUrl_addition1 = ref(false); //외부링크 -> 부가자료
    const exterUrl_addition2 = ref(false); //외부링크 -> 부가자료
    const exterUrl_addition3 = ref(false); //외부링크 -> 부가자료
    const purpTypeCd_sub1_options = ref([]); //외부링크 -> 부가자료
    const purpTypeCd_sub2_options = ref([]); //외부링크 -> 부가자료
    const purpTypeCd_sub3_options = ref([]); //외부링크 -> 부가자료
    const contentsUrl = ref(false); //콘텐츠 링크
    const webContents = ref(false); //웹 콘텐츠 등록

    const AddfileSeq = ref();  
    const AddcontSeq = ref();

    const popupType = props.parentType;
    const _saveType = props.saveType;
    const popupTextBookInfo = ref(false);

    const MppList = reactive([]);

    const _contSeq = props.contSeq;

    const loadData = async () => {
      // modal open
      data.params.fileSeq = props.fileSeq
      dataMpp.params.fileSeq = props.fileSeq
      dataMpp.params.contSeq = props.contSeq == -1 ? props.orgContSeq : props.contSeq;
      dataMpp.params.mappingSeq = props.mappingSeq
      data.params.mode = 'detail';

      let result = await getCsFileItem(data.params);
      data.row = result.data;

      if(props.fileSeq){
        if(_saveType == 'ins'){
          console.log(dataMpp);
          let resultMpp = await getMomentFileMappingItem(dataMpp.params);
          dataMpp.row = resultMpp.data;
          console.log(dataMpp.row);
          if(dataMpp.row.purpTypeCd == null){
            dataMpp.row.purpTypeCd = '';
          }
        }
        else if(_saveType == 'txt'){
          let resultMpp = await getCsFileMappingItem(dataMpp.params);
          dataMpp.row = resultMpp.data;
          if(dataMpp.row.purpTypeCd == null){
            dataMpp.row.purpTypeCd = '';
          }
        }
        else{
          let resultMpp = await getCsFileMappingList(dataMpp.params);
          dataMpp.row = resultMpp.data;
        }
        if(_saveType != 'ins' && _saveType != 'txt'){
        let resultMppList = await getCsFileMappingLocationList({
          fileSeq:props.fileSeq,
        });
        dataMppList.row = resultMppList.data;
        }

        if(data.row.fileTypeCd !=null){
          checkFileType(data.row.fileTypeCd);
        }
        fileSizeAddComma(data.row.size);
        settingKeywords(data.row.keywords);
        settingTags(data.row.tags);
        settingPurpTypeCd(dataMpp.row.purpTypeCd);
        console.log("modal OPEN : " + props.fileSeq);
      }else{
        let result = await getCsFileList(data.params);
        data.list = result.data;
        data.count = result.count;
        if(data.list.fileTypeCd !=null){
          checkFileType(data.list.fileTypeCd);
        }
        fileSizeAddComma(data.row.size);
        settingKeywords(data.row.keywords);
        settingTags(data.row.tags);
        settingPurpTypeCd(dataMpp.row.purpTypeCd);
        console.log("modal OPEN : " + props.fileSeq);
      }
      if(dataMpp.list.purpTypeCd == null){
          dataMpp.list.purpTypeCd  = '209001';
      }
      console.log('dataMpp.row:', dataMpp.row);
      if (!dataMpp.row.playStartTime && !dataMpp.row.playEndTime) {
        page.playAll = true;
      } else {
        page.playAll = false;
      }
    }
    const settingPurpTypeCd = (purpTypeCd) => {
      const sub = purpTypeCd_exterUrl_sub.find(sub => sub.value == purpTypeCd);
      if (data.row.fileTypeCd == '211003' && sub) { // 외부링크 -> 부가자료이면 하위 카테고리코드들 적용.
        let pCodes = (sub.p_code||'').split(',');
        pCodes.push(purpTypeCd);

        dataMpp.row.purpTypeCd = pCodes[0];
        dataMpp.row.purpTypeCd_sub1 = pCodes[1];
        dataMpp.row.purpTypeCd_sub2 = pCodes[2];
        dataMpp.row.purpTypeCd_sub3 = pCodes[3];

        exterUrl_addition1.value = true;
        exterUrl_addition2.value = true;
        exterUrl_addition3.value = true;

        purpTypeCd_sub1_options.value = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd && cd.p_code.endsWith(dataMpp.row.purpTypeCd));
        purpTypeCd_sub2_options.value = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd_sub1 && cd.p_code.endsWith(dataMpp.row.purpTypeCd_sub1));
        purpTypeCd_sub3_options.value = purpTypeCd_exterUrl_sub.filter(cd => dataMpp.row.purpTypeCd_sub2 && cd.p_code.endsWith(dataMpp.row.purpTypeCd_sub2));
      }
    }
    const settingKeywords = (text) => {
     if(text != null && text != ''){
        keywords.text = _.cloneDeep(text);
        keywords.box = _.cloneDeep(text.split(","));
        if(keywords.text.charAt(keywords.text.length-1) == ',' ){  // 마지막 
            keywords.box.map ((row , i)=>{
              if(row == ''){
                keywords.box.splice(i,1);
              }
          });
        }
      }
      text = '';
    }
    const settingTags = (text) => {
     if(text != null && text != ''){
      tags.text = _.cloneDeep(text);
      tags.box = _.cloneDeep(text.split(","));
      if(tags.text.charAt(tags.text.length-1) == ',' ){  // 마지막 
          tags.box.map ((row , i)=>{
            if(row == ''){
              tags.box.splice(i,1);
            }
          });
       }
     }
      text = '';
    }

    const checkFileType = (type) =>{
        switch(type){
          case '211001' : 
            docFile.value = true;
            mediaFile.value = false;
            exterUrl.value = false;
            contentsUrl.value = false;
            webContents.value = false;
          break;

          case '211002' : 
            docFile.value = false;
            mediaFile.value = true;
            exterUrl.value = false;
            contentsUrl.value = false;
            webContents.value = false;
          break;

          case '211003' : 
            docFile.value = false;
            mediaFile.value = false;
            exterUrl.value = true;
            contentsUrl.value = false;
            webContents.value = false;
          break;

          case '211004' : 
            docFile.value = false;
            mediaFile.value = false;
            exterUrl.value = false;
            contentsUrl.value = true;
            webContents.value = false;
          break;

          case '211005' : 
            docFile.value = false;
            mediaFile.value = false;
            exterUrl.value = false;
            contentsUrl.value = false;
            webContents.value = true;
          break;

          case null :
            docFile.value = true;
            mediaFile.value = false;
            exterUrl.value = false;
            contentsUrl.value = false;
            webContents.value = false;
          break;          
        }
    }

    const keywordChange = (box,text,type) =>{
      if(type == "key"){
        keywords.box = box;
        keywords.text = text;
        data.row.keywords = '';
      }else{
        tags.box = box;
        tags.text = text;
        data.row.tags = '';
      }
    }

    const keywordRemove = ( box , text , type) =>{
      if(type == "key"){
         keywords.box = box;
         keywords.text = text;
      }
      else{
        tags.box = box;
        tags.text = text;
      }
    }

    const insertFileName = (e) =>{
      var input = e.target;
      if (data.row.orgFileNm == input.files[0].name) {
        // 동일한 파일이름은 동일파일로 처리함.
        return;
      }

      fileName.value = input.files[0].name;
      if (input.files && input.files[0]) { 
        var reader = new FileReader();
        reader.onload = (e) => {
          // uploadImageFile.value = e.target.result; 
        }
        filedata.value = input.files[0];
        reader.readAsDataURL(input.files[0]);
        previewFileName.value = '';
        previewFileData.value = '';
        data.row.contentsViewFileUploadYn = 'N';
      }
    }
    const insertPreviewFileName = (e) =>{
      var input = e.target;
      previewFileName.value = input.files[0].name;
      if (input.files && input.files[0]) { 
        previewFileData.value = input.files[0];
      }
    }

    const downloadAs = (fileDivCd, url, name) => {
        let fullUrl = aws_cdn_path + url;
        Axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a1 = document.getElementById("fileDown");
          const url = window.URL.createObjectURL(response.data);
          a1.href = url;
          a1.download = name;
          a1.click();
        })
        .catch(err => {
          alert("error" + err);
        });
    };

    const goViewFileUrl = (url) => {
      const viewLink = document.getElementById("filePreview");
      const viewUrl = aws_cdn_path + url;
      viewLink.href = viewUrl;
      viewLink.click();
    }

    const openTabPreview = (url) => {
      if (url) {
        let newTab = window.open(url, '_blank');
        // if (newTab) newTab.document.title = '링크 미리보기';
        function check() {
          if(newTab.document) { // if loaded
            newTab.document.title = "링크 미리보기"; // set title
          } else { // if not loaded yet
              setTimeout(check, 10); // check in another 10ms
          }
        }
        check();
        // if (newTab) newTab.addEventListener("load", function() {
        //     newTab.document.title = '링크 미리보기';
        // });
      }
    }

    const fileSizeAddComma = (size) => {
      if(size === undefined){
        orgFileSize.value = 'KB';
      }else {
        size = size/1000;
        orgFileSize.value = size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'KB';
      }
    }

    const close = () =>{
        context.emit('get-data', {
          contSeq : props.contSeq,
          fileSeq : props.fileSeq,
          version : 'info'
      });
    }
    const txtclose = () =>{
      context.emit('get-data', {
        contSeq : props.orgContSeq,
        atrbInfo : props.atrbInfo,
        version : 'info'
      });
    }
    const saveClose = () =>{
        context.emit('refresh',{
          version : 'info',
          contSeq : props.contSeq,
        });
    }

    const insClose = () =>{
        context.emit('modal-state','info');
    }

    const popupOpen = (item,index) => {
      AddfileSeq.value = item.fileSeq
      AddcontSeq.value = item.orgContSeq

      dataMpp.row = _.cloneDeep(dataMppList.row[index]);

      popupTextBookInfo.value =true;
    }

    onMounted(loadData);
    
    return {
      close,
      txtclose,
      saveClose,
      purpTypeCd,
      purpTypeCd_exterUrl,
      purpTypeCd_exterUrl_sub,
      popupType,
      getFileTypeName,
      getFileDivName,
      page,
      data,
      dataMpp,
      keywords,
      tags,
      settingPurpTypeCd,
      settingKeywords,
      settingTags,
      docFile,
      mediaFile,
      exterUrl,
      exterUrl_addition1,
      exterUrl_addition2,
      exterUrl_addition3,
      purpTypeCd_sub1_options,
      purpTypeCd_sub2_options,
      purpTypeCd_sub3_options,
      contentsUrl,
      webContents,
      keywordChange,
      keywordRemove,
      // uploadImageFile,
      fileName,
      filedata,
      insertFileName,
      previewFileName,
      previewFileData,
      insertPreviewFileName,
      checkFileType,
      fileDivCdMap,
      downloadAs,
      goViewFileUrl,
      openTabPreview,
      fileSizeAddComma,
      orgFileSize,
      dataMppList,
      MppList,
      popupTextBookInfo,
      popupOpen,
      AddfileSeq,
      AddcontSeq,
      _contSeq,
      _saveType,
      insClose,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getCsFileList"] = getCsFileList;  // get list
  context["getCsFileItem"] = getCsFileItem;  // get item
  context["deleteCsFile"] = deleteCsFile;  // delete item
  context["deleteUpdateCsFile"] = deleteUpdateCsFile; // delete update item
  context["saveCsFile"] = saveCsFile;  // save item
  context["saveUpdateCsFile"] = saveUpdateCsFile; // save update(원본,미리보기) item
  context["getCsFileMappingItem"] = getCsFileMappingItem; // get item 
  context["getCsFileMappingList"] = getCsFileMappingList; // get item 
  context["saveCsFileMapping"] = saveCsFileMapping; // save item 
  context["deleteCsFileMapping"] = deleteCsFileMapping; // delete item
  context["getCsFileListByMomentMapp"] = getCsFileListByMomentMapp; // get csfileList by moment mapping
  context["deleteMomentFileMapping"] = deleteMomentFileMapping; // delete moment mapping item
  context["getMomentFileMappingItem"] = getMomentFileMappingItem; // get moment mapping item
  context["saveMomentFileMapping"] = saveMomentFileMapping; // save momentFileMapping item
    
  // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getCsFileList", context, _params);
  }

  // 상세
  async function edit(_item) {
    let _params = {
      fileSeq : _item.fileSeq
    }

    let fileInfo = await this.dataAction.execute("getCsFileItem", context, _params);

    this.settingKeywords(fileInfo.data.keywords);
    this.settingTags(fileInfo.data.tags);
  }

  //키워드 함수
  function settingKeywords(text){
    if(text != null && text != ''){
      let _keywords = this.clearKeyword();
      _keywords.text = _.cloneDeep(text);
      _keywords.box = _.cloneDeep(text.split(","));
      if(_keywords.text.charAt(_keywords.text.length-1) == ',' ){  // 마지막 
          _keywords.box.map ((row , i)=>{
              if(row == ''){
                _keywords.box.splice(i,1);
              }
          });
      }
      text = '';
    }
  }
  //태그 함수
  function settingTags(text){
    if(text != null && text != ''){
      let _tags = this.clearTag();
      _tags.text = _.cloneDeep(text);
      _tags.box = _.cloneDeep(text.split(","));
      if(_tags.text.charAt(_tags.text.length-1) == ',' ){  // 마지막 
          _tags.box.map ((row , i)=>{
              if(row == ''){
                _tags.box.splice(i,1);
              }
          });
      }
      text = '';
    }
  }

  // 맵핑정보 상세
  async function editMpp(_item) {
    edit(_item);
    console.log(this);
    let _params = {
      mappingSeq : _item.mappingSeq
    }
    console.log(this);
    if(_saveType == 'ins'){
      await this.dataAction.execute("getMomentFileMappingItem", context, _params);
    }else{
      await this.dataAction.execute("getCsFileMappingItem", context, _params);
    }
  }

  // delYn update
  async function updateDelete() {
    if (this.dataMppList.row.length>0) {
      alert("매핑목록이 있는 자료는 삭제할수 없습니다.");
      return;
    }
    let formData = new FormData();
    formData.append("fileSeq",this.data.row.fileSeq);
    let result = await deleteUpdateCsFile(formData);
    if(result != null){
      alert("삭제되었습니다.");
      this.close();
      this.insClose();
    }
  }

  // 삭제
  async function remove(_params) {
    _params = !_params ? this.data.row : _params
    //await this.dataAction.execute("deleteCsFile", context, _params);
    await deleteCsFile(_params);

    if (this._saveType == 'txt') {
      this.txtclose();
    } else {
      this.close();
    }
  }

  // 맵핑정보 삭제
  async function removeMpp(_params) {
    if (!confirm('삭제하시겠습니까?')) {
      return;
    }
    _params = !_params ? this.dataMpp.row : _params
    if(this._saveType =='ins'){
      let param = {
        mappingSeq : this.dataMpp.params.mappingSeq,
      }
      let result = await deleteMomentFileMapping(param);
      if(result.data){
          alert("맵핑정보가 삭제되었습니다.");
          this.saveClose();
      }
    } else if(this._saveType == 'txt'){
      let result = await deleteCsFileMapping(_params);
      if(result.data){
          alert("맵핑정보가 삭제되었습니다.");
          this.txtclose();
        }
      }
      else{
        this.close();
      }
  }

  // 저장
  async function save() {
    const validForm = await this.$validator.validateAll('edit').then((result) => {
      return result;
    });
    if (validForm) {
      let result;
      if (!!this.filedata || !!this.previewFileData) {
        let formData = new FormData();
        formData.append("fileSeq",this.data.row.fileSeq);
        formData.append("dispFileNm",this.data.row.dispFileNm);
        formData.append("teacherUseYn",this.data.row.teacherUseYn);
        formData.append("tutorUseYn",this.data.row.tutorUseYn);
        formData.append("studentUseYn",this.data.row.studentUseYn);
        formData.append("keywords",this.keywords.text);
        formData.append("tags",this.tags.text);
        formData.append("thumbnailPath",(this.data.row.thumbnailPath === undefined) ? '' : this.data.row.thumbnailPath);
        if (!!this.filedata) { // 원본파일 변경
          formData.append("mfile",this.filedata);
        }
        if (!!this.previewFileData) { // 미리보기파일 변경
          formData.append("contentsViewFileUploadYn",'Y');
          formData.append("mfilePreview",this.previewFileData);
        } else {
          formData.append("contentsViewFileUploadYn",'N');
        }
        result = await saveUpdateCsFile(formData);
      } else {
        let _params = this.data.row;
        _params.keywords = this.keywords.text;
        _params.tags = this.tags.text;
        result = await saveCsFile(_params);
      }
      if(result != null){
        alert("저장되었습니다.");
        if(this._saveType =='ins'){
          this.saveClose();
        }
        else{
          this.txtclose(); //교과서관리
        }
      }
      //await this.dataAction.execute("saveCsFile", context, _params);
    }
  }

  // 정보 저장 & 맵핑정보 저장
  async function saveAll() {
    const isValid = await this.$validator.validateAll('edit');
    const isValidMpp = await this.$validator.validateAll('editMpp');
    if (!isValid || (!isValidMpp && !this.page.playAll)) {
      console.log('isValid, isValidMpp', isValid, isValidMpp);
      alert('필수 입력 항목을 확인해주세요.');
      return false;
    }
    this.save();

    let _params = _.cloneDeep(this.dataMpp.row);
    let purpTypeCd = (this.dataMpp.row.purpTypeCd === undefined)? '' : this.dataMpp.row.purpTypeCd;
    if (this.data.row.fileTypeCd == '211003' && purpTypeCd == '209007') { // 외부링크 -> 부가자료이면 최 하단 카테고리코드 적용.
      purpTypeCd = this.dataMpp.row.purpTypeCd_sub3 || this.dataMpp.row.purpTypeCd_sub2 || this.dataMpp.row.purpTypeCd_sub1 || this.dataMpp.row.purpTypeCd;
    }
    if (this.data.row.fileTypeCd == '211003') { // 외부링크
      _params.purpTypeCd = purpTypeCd;
    }
    if(this._saveType == 'ins'){
      await saveMomentFileMapping(_params);
    }else{
      await saveCsFileMapping(_params);
    }
    this.search();
    return true;
  }

  // 초기화
  async function reset() {
    this.dataAction.clear();
  }

  function playAllChanged() {
    if (this.page.playAll) {
      this.dataMpp.row.playStartTime = null;
      this.dataMpp.row.playEndTime = null;
    }
  }

  return {reset, search, edit, editMpp, save, saveAll, remove, updateDelete, removeMpp, settingKeywords, settingTags, playAllChanged}

}
</script>
